/* eslint-disable react/prop-types */
import React from 'react';

const ClearButton = () => {
  const handleButtonClick = () => {
    window.location.href = window.location.pathname;
  };

  return (
    <button
      className="rounded py-1 px-3 text-xs font-medium text-primary  hover:shadow-card dark:text-white dark:hover:bg-boxdark"
      onClick={() => handleButtonClick()}
    >
      Clear Filter
    </button>
  );
};

export default ClearButton;
